import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import { useEstablishmentUserForm } from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';
import { auth } from '../../../firebase-init';
import { AuthContext } from '../../../Main';
import AxiosInstance from '../../../helpers/AxiosInstance';

const ListContractEstablishmentUser = (props) => {
  const { displayOptions, userEstablishmentId } = props;
  const [userEstablishment, setUserEstablishment] = useState(null);
  // AxiosInstance.get(`/establishment-user/${userEstablishmentId}`).then((res) => {
  //     AxiosInstance.get('/contract', { params: {...query, establishmentId: res.data.establishment.id } })
  //         .then((response) => {
  //             setListContract(response.data.items);
  //             setTotalPages(response.data.totalPages);
  //             setTotalItems(response.data.totalItems);
  //             setLoading(false);
  //         })
  //         .catch((error) => {
  //             Swal.fire(t('contract.ERROR_GET_CONTRACTS'), '', 'error');
  //             setLoading(false);
  //         });
  // });
  // useEffect(() => {
  //   AxiosInstance.get(`/establishment-user/${userEstablishmentId}`).then((res) => setUserEstablishment(res.data));
  // }, [userEstablishmentId]);
  const { attributes, actions, listContract, findAllContract, totalPages, loading, query } = useEstablishmentUserForm(
    displayOptions,
    userEstablishmentId
  );

  const { t } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('contract.title.list')} subtitle={t('contract.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listContract}
                loading={loading}
                search={findAllContract}
                numberOfPage={totalPages}
                query={query}
                textButton={displayOptions.addButton && t('contract.add')}
                linkButton={displayOptions.addButton && '/contract/add'}
                pdfTitle="Liste des Contrats"
                userRole={'establishment_user'}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListContractEstablishmentUser;
